import pkg from "../../package.json" assert { type: "json" };

/**
 * @fileoverview Constants for the Embedded SDK.
 * Re-exports all module events for backward compatibility.
 */

// Re-export core events
export { EVENT_PREFIX, IFRAME_EVENTS, CONTEXT_EVENTS } from "./events";

// Re-export module events
export { AUTH_EVENTS } from "../modules/auth/events";
export { PAGE_EVENTS } from "../modules/page/events";
export { NAV_EVENTS } from "../modules/nav/events";
export { UI_EVENTS } from "../modules/ui/events";
export { CHECKOUT_EVENTS } from "../modules/checkout/events";

/**
 * SDK version for debugging and compatibility checks.
 */
export const SDK_VERSION: string =
  (pkg as unknown as { version: string }).version || "";

/**
 * Default timeout for waiting for host responses (ms).
 */
export const DEFAULT_TIMEOUT = 10000;

/**
 * Trusted domains for message validation.
 * The host will validate based on iframe URL, but SDK validates for host messages.
 */
export const TRUSTED_DOMAINS = [
  "localhost",
  "merchants.workers.dev",
  "s.salla.sa",
  ".salla.group",
  ".salla.sa",
] as const;

/**
 * BCP-47 primary subtags whose scripts are written right-to-left.
 * Used as a fallback when the host omits `dir` from its layout payload.
 */
export const RTL_LANGS: ReadonlySet<string> = new Set([
  "ar", // Arabic
  "he", // Hebrew
  "fa", // Persian / Farsi
  "ur", // Urdu
  "ps", // Pashto
  "sd", // Sindhi
  "yi", // Yiddish
]);

/**
 * Derive text direction from a locale tag when the host doesn't provide one.
 * Accepts both BCP-47 (`ar-SA`) and underscore-separated (`ar_SA`) forms.
 */
export function inferDirFromLocale(locale: string | undefined): "rtl" | "ltr" {
  const primary = (locale ?? "ar").toLowerCase().split(/[-_]/)[0];
  return RTL_LANGS.has(primary) ? "rtl" : "ltr";
}
